import { Stack, Autocomplete, TextField, Chip } from '@mui/material';
import { z } from 'zod';
import { UniversalChartDataSchema } from '../../schemas';

export type EntityFilter = z.infer<typeof UniversalChartDataSchema>['filters']['entities'][number];

export interface BaseChartControlsProps {
	availableYears: string[];
	availableEntities: EntityFilter[];
	selectedYears: string[];
	selectedEntities: string[];
	onYearsChange: (years: string[]) => void;
	onEntitiesChange: (entities: string[]) => void;
	entityLabel: string;
	entityPlaceholder: string;
	groupByEntity?: boolean;
}

export function BaseChartControls({
	availableYears,
	availableEntities,
	selectedYears,
	selectedEntities,
	onYearsChange,
	onEntitiesChange,
	entityLabel,
	entityPlaceholder,
	groupByEntity = false,
}: BaseChartControlsProps) {
	return (
		<Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 2 }}>
			<Autocomplete
				multiple
				options={availableYears}
				value={selectedYears}
				onChange={(_, values) => onYearsChange(values)}
				renderInput={(params) => (
					<TextField
						{...params}
						label="Chọn năm"
						placeholder="Tất cả năm"
						size="small"
					/>
				)}
				renderTags={(value, getTagProps) =>
					value.map((option, index) => (
						<Chip
							{...getTagProps({ index })}
							key={option}
							label={option}
							size="small"
						/>
					))
				}
				sx={{ minWidth: 200, flex: 1 }}
				limitTags={3}
				disableCloseOnSelect
			/>
			<Autocomplete
				multiple
				options={availableEntities}
				getOptionLabel={(option) => option.name}
				getOptionKey={(option) => option.code}
				isOptionEqualToValue={(option, value) => option.code === value.code}
				value={availableEntities.filter(e => selectedEntities.includes(e.code))}
				onChange={(_, values) => onEntitiesChange(values.map(v => v.code))}
				renderInput={(params) => (
					<TextField
						{...params}
						label={entityLabel}
						placeholder={entityPlaceholder}
						size="small"
					/>
				)}
				renderTags={(value, getTagProps) =>
					value.map((option, index) => (
						<Chip
							{...getTagProps({ index })}
							key={option.code}
							label={option.name}
							size="small"
						/>
					))
				}
				{...(groupByEntity ? { groupBy: (option: EntityFilter) => option.groupName || 'Khác' } : {})}
				sx={{ minWidth: 300, flex: 1 }}
				limitTags={3}
				disableCloseOnSelect
			/>
		</Stack>
	);
}
